import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from "recharts";

const COLORS = ["#0EA5E9", "#8B5CF6", "#F59E0B"];

const AudienceUserTypes = ({ summary }) => {
    const data = [
        { name: "Guests", value: summary.guest_visitors },
        { name: "Artists", value: summary.artists },
        { name: "Organizations", value: summary.organizations },
    ];

    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-sky-50/40 to-white p-5">
            <h2 className="text-sm font-semibold text-slate-900">Visitor Types</h2>
            <p className="mb-3 text-xs text-slate-500">Distribution of registered audience</p>

            <div className="h-56">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart layout="vertical" data={data} margin={{ left: -10 }}>
                        <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#E0F2FE" />
                        <XAxis type="number" tick={{ fontSize: 11 }} allowDecimals={false} />
                        <YAxis dataKey="name" type="category" width={90} tick={{ fontSize: 12 }} />
                        <Tooltip contentStyle={{ borderRadius: 10, border: "1px solid #E2E8F0", fontSize: 12 }} cursor={{ fill: "#F8FAFC" }} />
                        <Bar dataKey="value" radius={[0, 6, 6, 0]} maxBarSize={26}>
                            {data.map((entry, i) => (
                                <Cell key={i} fill={COLORS[i % COLORS.length]} />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default AudienceUserTypes;